import {Route, Routes} from 'react-router-dom'
// import {Registration} from './components/Registration'
// import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import InviteRegistration from './components/InviteRegistration'
import ForgotPassword from './components/ForgotPassword'
import ChangePassword from './components/ChangePassword'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      {/* <Route path='registration' element={<Registration />} /> */}
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='change-password/:userId/:token' element={<ChangePassword />} />
      <Route path='invite/:userId/:token' element={<InviteRegistration />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
